import { render, staticRenderFns } from "./UserDevicesModal.vue?vue&type=template&id=4b3c6376&"
import script from "./UserDevicesModal.vue?vue&type=script&lang=js&"
export * from "./UserDevicesModal.vue?vue&type=script&lang=js&"
import style0 from "./UserDevicesModal.vue?vue&type=style&index=0&id=4b3c6376&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports